function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -937.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Website",
  transform: "translate(0.000000, 909.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#596F98",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#7891C1",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.66225353,19.9339068 L8.15625381,20.4364065 C7.71762906,20.8711563 7.00425445,20.8715313 6.5658797,20.4364065 C6.35512982,20.2272816 6.23937988,19.9495318 6.23937988,19.6542819 C6.23937988,19.3590321 6.35525482,19.0811573 6.5657547,18.8720324 L8.42825366,17.0241584 C8.81425345,16.6414086 9.54037804,16.0777839 10.0696277,16.6026586 C10.3125026,16.8439085 10.7047524,16.8422835 10.9458773,16.5995336 C11.1871271,16.3567838 11.1856271,15.964409 10.9427523,15.7234091 C10.0431278,14.8306596 8.7135035,14.9956595 7.55550415,16.1446589 L5.69288018,17.9926579 C5.24600543,18.4362826 5.00000557,19.0262823 5.00000557,19.6542819 C5.00000557,20.2822816 5.24600543,20.8721563 5.69300518,21.315781 C6.15287993,21.7720308 6.75675459,22.0000306 7.36087926,22.0000306 C7.96512892,22.0000306 8.56925358,21.7720308 9.02937833,21.315531 L9.53575304,20.8129063 C9.77850291,20.5719064 9.77987791,20.1796567 9.53862804,19.9367818 C9.29775318,19.6941569 8.9051284,19.6927819 8.66225353,19.9339068 Z M14.3067504,12.7555358 C13.3405009,11.7967863 11.9895017,11.7447864 11.0950022,12.6322859 L10.4642525,13.2584105 C10.2213777,13.4995354 10.2198777,13.8916602 10.4611275,14.134535 C10.7023774,14.3774099 11.0946272,14.3787849 11.337502,14.13766 L11.9680017,13.5119104 C12.4313764,13.0517856 13.0381261,13.2425355 13.4338759,13.6351603 C13.6448758,13.8442852 13.7607507,14.12216 13.7607507,14.4174099 C13.7607507,14.7127847 13.6447508,14.9906595 13.4341259,15.1997844 L11.447002,17.1710333 C10.5383775,18.0725328 10.1121277,17.6494081 9.93025282,17.4689082 C9.68737796,17.2277833 9.29525318,17.2292833 9.05400331,17.4720332 C8.81275345,17.714783 8.81425345,18.1071578 9.05712831,18.3481577 C9.47425308,18.7621574 9.95037781,18.9674073 10.4495025,18.9674073 C11.0606272,18.9674073 11.7061268,18.6596575 12.3198765,18.0502828 L14.3070004,16.0790339 C14.7537501,15.6354092 15,15.0452845 15,14.4172849 C15,13.7895352 14.7537501,13.1994105 14.3067504,12.7555358 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})))));

var SvgUrl = function SvgUrl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUrl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/url.c2e0c961.svg";
export { ForwardRef as ReactComponent };